import React, { ReactNode } from "react";
import AvatarPlaceHolder from "./../../images/user-image-placeholder.png";
import EditPen from "./../../images/edit-pen.svg";
import { Colors } from "../../Constants/colors";

interface Props {
  avatar?: string;
  children: ReactNode;
}
export const Profile = ({ avatar = AvatarPlaceHolder, children }: Props) => {
  return (
    <div>
      <div className="h-24">
        <div
          style={{
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            // overflow: 'hidden',
            position: "relative",
          }}
        >
          <img
            src={avatar}
            alt="avatar"
            style={{ width: "100%", height: "100%" }}
          />
          <div
            className="w-7 h-7"
            style={{
              position: "absolute",
              top: -4,
              right: -4,
              borderRadius: "50%",
              backgroundColor: Colors.White,
              padding: "4px",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              cursor: "pointer",
            }}
          >
            <img
              src={EditPen}
              alt="pen"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
};
